import { LucideProps } from 'lucide-react';

export const Link = (props: LucideProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.41646 14.3032L8.23794 15.4817C6.61076 17.1089 3.97257 17.1089 2.34539 15.4817C0.718204 13.8546 0.718204 11.2164 2.34539 9.58919L3.5239 8.41068M14.1305 9.58919L15.309 8.41067C16.9362 6.78349 16.9362 4.1453 15.309 2.51812C13.6818 0.890933 11.0436 0.890933 9.41646 2.51812L8.23794 3.69663M5.91053 11.9166L11.7439 6.08325"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
